import React from 'react'
import { View, Text, StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  container: {
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#dee2e6',
  },
  text: {
    color: '#6c757d',
    textAlign: 'center',
  },
})

export const createFallbackComponent = message => {
  const FallbackVideoPlayer = ({ style }) => (
    <View style={[styles.container, style]}>
      <Text style={styles.text}>{message}</Text>
    </View>
  )

  return FallbackVideoPlayer
}

export default createFallbackComponent(
  'Video playback requires the optional Video Player package.'
)
